// import {
//     temAcesso
// } from '@/shared/auth/temAcesso'
// import projetosRotas from './projetos/ProjetosRotas'
// import entregasRotas from './entregas/EntregasRotas'
import pagamentosRotas from './pagamentos/PagamentosRotas'

export default {
    path: 'financeiro',
    name: 'Gescon_Financeiro',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [pagamentosRotas]
}
